import axios from '@/http/index';

const base = '';
// 取消预约
export const getBookFailures = (params) => axios.get(`${base}/erp/bookOrder/bookFailures`, params).then((res) => res.data);
// 获得会员卡相关信息
export const getMemberCardMsg = (params) => axios.get(`${base}/erp/member/getMemberCardMsg`, params).then((res) => res.data);
// 获得预约列表
export const getBookOrderList = (params) => axios.get(`${base}/erp/bookOrder/getBookOrderList`, params).then((res) => res.data);
// 获得项目列表
export const getItemLIst = (params) => axios.get(`${base}/erp/technicianOrder/getItemList`, params).then((res) => res.data);
// 获得统称预约时间段
export const postTechnicianOrderList = (params) => axios.post(`${base}/erp/technicianOrder/getTechnicianOrderList`, params).then((res) => res.data);
// 保存预约信息
export const postSaveBookOrder = (params) => axios.post(`${base}/erp/technicianOrder/saveBookOrder`, params).then((res) => res.data);
// 获得项目分类列表
export const getItemTypeLIst = (params) => axios.get(`${base}/erp/technicianOrder/getItemTypeLIst`, params).then((res) => res.data);
// 获得预约开单需要的信息
export const getBilling4Book = (params) => axios.get(`${base}/erp/bookOrder/getBilling4Book`, params).then((res) => res.data);
// 获得预约统称列表
export const getFansTechnicianList = (params) => axios.get(`${base}/erp/technicianOrder/getFansTechnicianList`, params).then((res) => res.data);
// 获得预约师页面选择时间段和项目信息(预约统称)
export const getTimeList = (params) => axios.get(`${base}/erp/technicianOrder/getAppointmentIntervalAndItemList`, params).then((res) => res.data);
// (3.6.1)获得预约师页面选择时间段和统称信息(预约项目)
export const getProjectTimeList = (params) => axios.get(`${base}/erp/technicianOrder/getAppointmentIntervalAndTechnicianList`, params).then((res) => res.data);
// 获取预约最长时间（月）
export const getLongBook = (params) => axios.get(`${base}/erp/lookBookGlobal/getLongBook`, params).then((res) => res.data);
